import { Customer } from "./customer";
import { Staff } from "./staff";

export interface OpportunityFile {
  name: string;
  url: string;
}

export enum OpportunityStatus {
  GetRequest = "GET_REQUEST",
  MakePlan = "MAKE_PLAN",
  MakeQuote = "MAKE_QUOTE",
  WaitApprove = "WAIT_APPROVE",
}

export enum QuoteStatus {
  WaitSend = "WAIT_SEND",
  Sent = "SENT",
  Negotiate = "NEGOTIATE",
  Revise = "REVISE",
  WaitApprove = "WAIT_APPROVE",
  CloseOrder = "CLOSE_ORDER",
  Failed = "FAILED",
}

export interface OpportunityDetail {
  id: number;
  description: string;
  unit: string;
  quantity: number;
  price: number;
}

export interface Opportunity {
  id: number;
  createdAt: number;
  updatedAt: number;
  code: string;
  name: string;
  customerDescription: string;
  internalNote: string;
  status: OpportunityStatus;
  quoteStatus: QuoteStatus | null;
  failReason: string;
  customerFiles: OpportunityFile[];
  internalFiles: OpportunityFile[];
  links: string[];
  totalAmount?: number;
  orderId?: number | null;
  customer: Customer | null;
  createdStaff?: Staff | null;
  opportunityDetails?: OpportunityDetail[];
}

export interface OpportunityCounts {
  all: number;
  noQuote: number;
  statuses: Record<OpportunityStatus, number>;
  quoteStatuses: Record<QuoteStatus, number>;
}
